import React from 'react';
import './AuthButtons.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

function AuthButtons() {
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  // Facebook login - temporarily disabled
  // const handleFacebookLogin = () => {
  //   window.location.href = `${API_URL}/auth/facebook`;
  // };

  // Apple login - temporarily disabled
  // const handleAppleLogin = () => {
  //   window.location.href = `${API_URL}/auth/apple`;
  // };

  return (
    <div className="auth-buttons">
      <button onClick={handleGoogleLogin} className="auth-btn google-btn">
        <span className="auth-icon">G</span>
        Continue with Google
      </button>

      {/* Facebook login - temporarily disabled
      <button onClick={handleFacebookLogin} className="auth-btn facebook-btn">
        <span className="auth-icon">f</span>
        Continue with Facebook
      </button>
      */}

      {/* Apple login - temporarily disabled
      <button onClick={handleAppleLogin} className="auth-btn apple-btn">
        <span className="auth-icon">🍎</span>
        Continue with Apple
      </button>
      */}
    </div>
  );
}

export default AuthButtons;